import styled from 'styled-components';
import { TextBold, TextMedium } from '../../styles/GlobalStyledComponents';

export const ModalContainer = styled.div`
  width: 600px;
  height: 90%;
  position: fixed;
  background-color: white;
  border: solid 1px gray;
  z-index: 99;
  top: 5vh;
  left: calc(50% - 300px);
  padding: 25px;
  border-radius: 16px;

  @media (max-width: 850px) {
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 48px);
    padding: 16px;
    margin-top: 48px;
    border-radius: 16px 16px 0 0;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DetailTextWrapper = styled.div`
  margin: 8px 0;
  line-height: 20px;

  @media (max-width: 650px) {
    margin: 16px 0;
  }
`;

export const DebtDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const DebtWrapper = styled.div`
  padding: 12px 10px 10px 10px;
  border: 1px solid ${(props) => props.theme.colors.red10};
  border-radius: 12px;
  gap: 8px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const PriceText = styled(TextBold)`
  width: 100%;
`;

export const QuotaWrapper = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.gray12};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
`;
export const QuotaTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  @media (max-width: 650px) {
    flex-wrap: wrap;
  }
`;

export const QuotaPill = styled.div`
  border-radius: 100px;
  padding: 8px 10px;
  background-color: ${(props) => props.theme.colors.red6};
`;

export const QuotaBodyWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0;
`;
export const QuotaData = styled.div`
  width: 100%;
  gap: 15px;
  display: flex;
  align-items: baseline;
  padding: 10px 5px 0px 0px;
  span:first-child {
    width: 90%;
  }
  @media (max-width: 650px) {
    width: 100%;
    padding: 5px;
  }

  @media (max-width: 450px) {
    gap: 0px;
  }
`;

export const QuotaInfoTitle = styled(TextMedium)`

  @media (max-width: 420px) {
    font-size: 12px;
  }
`;

export const QuotaInfoDetail = styled(TextBold)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const LoanInfo = styled.span``;

export const Hr = styled.hr`
  border: 1px solid ${(props) => props.theme.colors.gray11};
  margin-top: 12px;
`;

export const ScrollableQuotaList = styled.div`
  margin-bottom: 12px;
`;

export const QuotaListContainer = styled.div`
  height: calc(100% - 176px);
  max-height: 100%;
  padding: 8px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.red7} #f1f1f1;
`;